import {BaseEvent} from "./BaseEvent";

export class DeleteChartEvent extends BaseEvent {
  public static NAME = 'deleteChart';
  value: number;

  constructor(id: number) {
    super(DeleteChartEvent.NAME);
    this.value = id;
  }
}
